import React, { useState } from "react";
import { HvButton, HvDialogActions, HvDialogContent, HvDialogTitle, HvTextArea } from "@hitachivantara/uikit-react-core";
import { Box, makeStyles } from "@material-ui/core";
import { HvDrawer } from '@hitachivantara/uikit-react-lab';
import LabService from "services/LabService";
import { useDispatch } from 'react-redux';
import { showBanner } from 'redux/actions/bannerActions';
import Rating from "@mui/material/Rating";
import Stack from '@mui/material/Stack';
import _ from 'lodash'


const FeedbackDrawer = (props) => {

    const { handleDrawerState, openDrawer, labId } = props
    const labServiceObj = new LabService();
    const [feedback, setFeedback] = useState();
    const [rating, setRating] = useState(0)
    const dispatch = useDispatch();
    const drawerWidth = "70%";

    const useStyles = makeStyles(() => ({
        drawerPaper: {
            width: `calc(100% - ${drawerWidth})`,
            overflow: "unset", // we want scroll content, not scroll paper
            padding: "12px",
            ' & .HvDialogTitle-root:not(.fullscreen)': {
                flex: 'none'
            },
            ' & .HvTypography-xxsTitle': {
                font: 'normal normal 600 20px/24px Open Sans',
                letterSpacing: '0px',
                color: '#414141',
                opacity: 1,

            }
        },
        drawerContent: {
            // maximize space for content
            flex: 1,
            overflow: "auto",
            '&::-webkit-scrollbar': {
                width: '4px'
            },
            '&::-webkit-scrollbar-thumb': {
                background: '#CCCED0 0% 0% no-repeat padding-box',
                borderRadius: '2px',
            }
        },
        tabs: {
            borderBottom: '2px solid #E8E8E8',
            margin: '20px 20px 0px 20px',
            '& .HvTab-root::after': {
                backgroundColor: 'unset'
            }
        },
        action: {
            flex: 'none',
            height: '72px'
        }
    }));
    const classes = useStyles();

    const submitFeedback = () => {
        if (_.isEmpty(feedback)) {
            dispatch(showBanner({
                payload: {
                    showBanner: true,
                    label: { message: "Feedback can not be empty." },
                    variant: "error"
                }
            }))
        } else {
            labServiceObj.submitFeedback({ "lab_id": labId, "message": feedback,"rating": _.isNull(rating) ?  0 : rating }).then((response) => {
                if (response?.id) {
                    dispatch(showBanner({
                        payload: {
                            showBanner: true,
                            label: { message: "Thank for your feedback." },
                            variant: "success"
                        }
                    }))
                    props.handleDrawerState(false)
                }

            }).catch((error) => { console.log(error) })
        }
    }
    return (
        <div>
            <HvDrawer
                id="drawer-test"
                open={openDrawer}
                classes={{
                    paper: classes.drawerPaper,
                }}
                onClose={() => handleDrawerState(false)}
                hideBackdrop
            >
                <HvDialogTitle className={classes.drawerTitle}>Feedback</HvDialogTitle>
                <HvDialogContent className={classes.drawerContent}>
                    <Stack spacing={1}>
                        <Rating name="size-medium" defaultValue={rating} onChange={(event, newValue)=>{setRating(newValue)}} precision={1} readOnly={false} />
                        <HvTextArea id="main" label="Message" placeholder="Enter text" rows={17} onChange={(e) => { setFeedback(e.target.value) }} />
                    </Stack>
                    
                </HvDialogContent>
                <HvDialogActions className={classes.action}>
                    <Box display="flex">
                        <HvButton category="secondary" onClick={() => { props.handleDrawerState(false) }}>Cancel</HvButton>
                        <HvButton category="primary" style={{ marginLeft: '10px' }} onClick={submitFeedback}>Submit</HvButton>
                    </Box>
                </HvDialogActions>
            </HvDrawer>
        </div>
    );
}

export default FeedbackDrawer;